type Orderable = { id: string; seo: unknown };

const isWorkItem = (page: Orderable) =>
  Boolean(
    page.seo &&
      typeof page.seo === "object" &&
      !Array.isArray(page.seo) &&
      (page.seo as { work?: unknown }).work === true,
  );

/**
 * The page ids in their new order after moving a page one step among pages of
 * its own kind (standard pages or work items), or null when it can't move.
 * Pages of the other kind keep their places, so the move is always visible in
 * the list the page belongs to.
 */
export const movedOrder = (
  pages: Orderable[],
  pageId: string,
  delta: -1 | 1,
): string[] | null => {
  const page = pages.find((p) => p.id === pageId);
  if (!page) return null;
  const kind = isWorkItem(page);
  const siblings = pages.filter((p) => isWorkItem(p) === kind);
  const neighbour = siblings[siblings.findIndex((p) => p.id === pageId) + delta];
  if (!neighbour) return null;
  const ids = pages.map((p) => p.id);
  const from = ids.indexOf(pageId);
  const to = ids.indexOf(neighbour.id);
  [ids[from], ids[to]] = [ids[to], ids[from]];
  return ids;
};

export const canMovePage = (
  pages: Orderable[],
  pageId: string,
  delta: -1 | 1,
) => movedOrder(pages, pageId, delta) !== null;
